<ng-container *transloco="let t">
@for (group of docGroups; track group.documentTypeName; let i = $index) {
  <div class="accordion" id="kt_accordion_{{i}}">
    <div class="accordion-item">
        <h2 class="accordion-header" id="kt_accordion_header_{{i}}">
            <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#kt_accordion_body_' + i" aria-expanded="false">
              {{ group.documentTypeName }}
            </button>
        </h2>
        <div id="kt_accordion_body_{{i}}" class="accordion-collapse collapse"  [attr.data-bs-parent]="'#kt_accordion_' + i">
            <div class="accordion-body">
              @for (document of group.docs; track document.fileGuid) {
                <view-document
                  [document]="document"
                ></view-document>
              }
            </div>
        </div>
    </div>
  </div>
}


@if (documents.length === 0) {
  <h3 class="text-center my-4">
    {{ t('portal.tasks.noDocuments') }}
  </h3>
}
</ng-container>
